import React from 'react';
import {Pagination} from "react-bootstrap";
import {router} from "@inertiajs/react";

export default function InertiaPagination({links,updateOnly}) {

    function getClassName(active) {
        if (active) {
            return "mr-1 mb-1 px-4 py-3 text-sm leading-4 border rounded hover:bg-white focus:border-primary focus:text-primary bg-blue-700 text-white";
        } else {
            return "mr-1 mb-1 px-4 py-3 text-sm leading-4 border rounded hover:bg-white focus:border-primary focus:text-primary";
        }
    }

    let reloadOptions = {preserveState:true};
    if (updateOnly){
        reloadOptions.only = [...['filters'] ,...updateOnly];
    }

    return ( links && links.length > 3 && (
            <Pagination>
                {links.map((link, key) => (
                    <Pagination.Item onClick={(e) => {router.visit( link.url,reloadOptions);}} active={link.active}
                                     disabled={link.url === null}><span dangerouslySetInnerHTML={{__html: `${link.label}`}}></span></Pagination.Item>)
                )}
            </Pagination>
            )
    );
}
